import { forOwn } from 'lodash';
import React, { useEffect, useState } from 'react';
import { getAppSettingsEnvironment } from '../../api/userapi';

export const SystemInfoView = ({showTitle}) => {
    const [environment, setEnvironment] = useState('')

    useEffect(() => {
        const fetchGetSettings = async () => { getAppSettingsEnvironment({ callback:setEnvironment }) }
        fetchGetSettings()
    }, [])

    const getEnvironment = () => {
        switch (environment) {
            case 'dev':
              return 'Dev - '
            case 'qa':
              return 'QA - '
            case 'staging':
              return 'Staging - '
            default:
              return ''
        }
    }
      
    return (
        <>
            <span className='title-login-logo'>{showTitle ? "GIFT CENTER PORTAL" : ""}</span>
            <span className='application-version'>{getEnvironment()}v{process.env.REACT_APP_VERSION}</span>
        </>
    );
}
